export const Types = {
    SUBMIT_DELETE: "SUBMIT_DELETE",
    DELETE_COMPLETE: "DELETE_COMPLETE",
    START_DELETE: "START_DELETE",
    END_DELETE: "END_DELETE"
};

export const startDeleteAction = (resource, resourceId, additionalResourceIds, additionalData, postDeleteActions) => ({
    type: Types.START_DELETE,
    deleteResource: resource,
    deleteResourceId: resourceId,
    additionalResourceIds: additionalResourceIds,
    additionalData: additionalData,
    postDeleteActions: postDeleteActions
});

export const submitDeleteAction = (challengeId) => ({
    type: Types.SUBMIT_DELETE,
    challengeId: challengeId
});

export const deleteCompleteAction = () => ({
    type: Types.DELETE_COMPLETE
});

export const endDeleteAction = () => ({
    type: Types.END_DELETE
});



// WEBPACK FOOTER //
// ./public/pages/DeleteConfirmation/actions.js